import { DEFAULT_TIMER } from '../../../../../utils/time';
import { useCountdownTimer } from '../../../hooks';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface MonetizationWidgetTimerProps {
  endDate: Date;
  onEnd: () => void;
  extended: boolean;
}

export function MonetizationWidgetTimer(props: MonetizationWidgetTimerProps) {
  const { endDate, onEnd, extended } = props;
  const { timer } = useCountdownTimer({ onEnd, endDate });
  return <GeneralWidgetTimer extended={extended} timerValue={timer || DEFAULT_TIMER} />;
}
